import { getDataStoreEntityMap } from '../../../modules/chat/dataStoreEntityMap'

const selectChatGroups = state => getDataStoreEntityMap(state.data.chatGroups)

const selectChatGroupById = chatGroupId => state => selectChatGroups(state)[chatGroupId]

const ChatGroupDataStoreSelectors = {
  chatGroups: selectChatGroups,
  chatGroupById: selectChatGroupById
}

export default ChatGroupDataStoreSelectors
